export const RAFFLE_EVENT_LIST_REQUEST = 'RAFFLE_EVENT_LIST_REQUEST';

export const RAFFLE_EVENT_UPSERT_REQUEST = 'RAFFLE_EVENT_UPSERT_REQUEST';

export const RAFFLE_EVENT_INFO_REQUEST = 'RAFFLE_EVENT_INFO_REQUEST';

export const RAFFLE_EVENT_HISTORY_LIST_REQUEST = 'RAFFLE_EVENT_HISTORY_LIST_REQUEST';